export const AUTH_API = {
  REGISTER: '/users/register',
  LOG_IN: '/users/login',
  LOG_IN_GMAIL: '/users/gmail-login',
  LP_TOKEN_LOG_IN: '/users/lptoken-login',
  LOG_OUT: '/users/logout',
  FORGOT_PASSWORD: '/users/reset-password',
  UPDATE_RESET_PASSWORD: '/users/update-reset-password',
  UPDATE_PASSWORD: '/users/update-password',
  UPDATE_USER_NAME: '/users/register-agency-user',
  FETCH_OTP_VIA_EMAIL: '/users/send-verify-email',
  VERIFY_OTP_VIA_EMAIL: '/users/verify-email',
  FAVORITE_GAME: '/games/games-favorite',
  CHECK_USERNAME_EXISTS: '/users/checkUserExists',
}

export const GAME_API = {
  TOP_WINNING_GAME: '/top-winning',
  TOP_CHAMPION: '/top-champion',
  GAMES: '/games',
  PLAY_GAME: '/games/play',
}

export const LIVE_CASINO_API = {
  PROVIDERS: '/games/livecasino/providers',
  LIVE_CASINO: '/games/livecasino',
  CATEGORIES: '/games/livecasino/categories',
}

export const APP_API = {
  BANNERS: '/cms/banners',
  HOT_MATCHES: '/media/hot-match',
  JACKPOT: '/games/jackpot',
}

export const NEWS_API = {
  POSTS: '/cms/news/posts',
  POST_DETAIL: '/cms/news/post',
  CATEGORY: '/cms/news/category',
  CATEGORIES: '/cms/news/categories',
}

export const DEPOSIT_WITHDRAW_API = {
  DEPOSIT_BANK: '/transaction/add-invoice',
  DEPOSIT_MOMO: '/transaction/add-invoice-momo',
  DEPOSIT_CARD: '/transaction/add-invoice-phone-card',
  WITHDRAW_BANK: '/transaction/add-invoice-withdraw',
  WITHDRAW_BANK_LIST: '/transaction/withdraw-banks',
  WITHDRAW_CARD: '/transaction/add-invoice-withdraw-phone',
  WITHDRAW_CRYPTO: '/transaction/add-invoice-withdraw-crypto',
  BANK_ACCOUNT: '/transaction/bank-account',
  PHONE_CARD_LIST: '/transaction/phone-card',
  EWALLET_LIST: 'transaction/ewallet-list',
  BANK_SCHEDULE: '/transaction/bank-schedule',
}

export const DEPOSIT_API = {
  DEPOSIT_E_WALLET_LIST: '/transaction/ewallet-list',
  DEPOSIT_E_WALLET_CODE: '/transaction/ewallet-code',
  DEPOSIT_NICEPAY: '/transaction/nicepay-invoice',
  DEPOSIT_SENPAY: '/transaction/senpay-invoice',
}

export const CRYPTO_API = {
  CRYPTO: '/transaction/crypto',
  INVOICE_STATUS: '/transaction/invoice-status',
  ADD_INVOICE_CRYPTO: '/transaction/add-invoice-crypto',
  CANCEL_INVOICE_CRYPTO: '/transaction/cancel-crypto-invoice',
}

export const SPORTS = {
  FOOTBALL_SCHEDULE: '/media/hot-match/fixture',
  HOT_MATCH_API: '/media/hot-match',
}

export const LOTTERY_API = {
  LOTTERY_CITY: '/lotte/cities',
  LOTTERY_RESULTS: '/lotte/results',
}

export const LOBBY_GAME_API = {
  PG_SOFT_GAMES_ENTRY: `pg-soft-games/game-launcher`,
}
